module.exports = __webpack_public_path__ + "static/media/dropdown-blue.80a3ae25.svg";